import React from 'react';
import { motion } from 'framer-motion';
import { BotIcon, UsersIcon, SparklesIcon, RocketIcon } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
export function CrobotShowcase() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 md:py-32 px-6 md:px-12 lg:px-20 z-10 relative" data-id="element-120">
      <div className="max-w-[1400px] mx-auto" data-id="element-121">
        <div className="border-t border-border pt-16 md:pt-20" data-id="element-122">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="mb-14 md:mb-16" data-id="element-123">
            <div className="flex items-center gap-3 mb-4" data-id="element-124">
              <BotIcon className="w-4 h-4 text-secondary/60" data-id="element-125" />
              <p className="text-secondary text-xs tracking-[0.2em] uppercase font-light" data-id="element-126">
                {t.crobotOverline}
              </p>
            </div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold text-primary tracking-tight mb-6 leading-snug" data-id="element-127">
              {t.crobotTitle}
            </h2>
            <p className="text-secondary text-base md:text-lg font-light max-w-2xl leading-relaxed" data-id="element-128">
              {t.crobotDesc}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-129">
            {/* Left — Video */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7,
            ease: [0.16, 1, 0.3, 1]
          }} className="group block" data-id="element-130">
              <div className="relative overflow-hidden rounded-lg bg-surface border border-border/50" data-id="element-131">
                <div className="flex items-center gap-1.5 px-4 py-2.5 bg-surface border-b border-border/50" data-id="element-132">
                  <div className="w-2 h-2 rounded-full bg-white/10" data-id="element-133" />
                  <div className="w-2 h-2 rounded-full bg-white/10" data-id="element-134" />
                  <div className="w-2 h-2 rounded-full bg-white/10" data-id="element-135" />
                  <div className="ml-3 flex-1 h-4 rounded bg-white/5 max-w-[140px]" data-id="element-136" />
                </div>
                <div className="relative aspect-video overflow-hidden bg-[#0A0A0A]" data-id="element-137">
                  <video src="https://cdn.magicpatterns.com/uploads/nMVDh2auSFMWDftFjxTnV4/crobot.mp4" autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover object-[15%_center] transition-transform duration-700 ease-out group-hover:scale-[1.02]" data-id="element-138" />
                  <div className="absolute inset-0 bg-background/0 group-hover:bg-background/10 transition-colors duration-500 pointer-events-none" data-id="element-139" />
                </div>
              </div>
            </motion.div>

            {/* Right — Details */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7,
            delay: 0.15,
            ease: [0.16, 1, 0.3, 1]
          }} className="flex flex-col justify-center" data-id="element-140">
              <p className="text-secondary text-sm md:text-base font-light leading-relaxed mb-10" data-id="element-141">
                {t.crobotDetail}
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10" data-id="element-142">
                {[{
                icon: UsersIcon,
                value: '700+',
                label: t.crobotStat1
              }, {
                icon: SparklesIcon,
                value: '1st',
                label: t.crobotStat2
              }, {
                icon: RocketIcon,
                value: '100%',
                label: t.crobotStat3
              }].map((stat, i) => <motion.div key={stat.label} initial={{
                opacity: 0,
                y: 15
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: 0.3 + i * 0.1,
                ease: [0.16, 1, 0.3, 1]
              }} whileHover={{
                y: -5,
                scale: 1.02
              }} className="p-5 rounded-xl border border-border/50 bg-surface/30 hover:bg-surface/80 hover:border-secondary/30 transition-all duration-300 group/stat flex flex-col items-center sm:items-start text-center sm:text-left cursor-default" data-id="element-143">
                    <div className="w-10 h-10 rounded-full bg-primary/5 flex items-center justify-center mb-4 group-hover/stat:bg-primary/10 transition-colors" data-id="element-144">
                      <stat.icon className="w-4 h-4 text-secondary/60 group-hover/stat:text-primary transition-colors" data-id="element-145" />
                    </div>
                    <div className="text-2xl md:text-3xl font-display font-bold text-primary tracking-tight leading-none mb-2" data-id="element-146">
                      {stat.value}
                    </div>
                    <div className="text-[10px] text-secondary/50 tracking-[0.15em] uppercase font-light" data-id="element-147">
                      {stat.label}
                    </div>
                  </motion.div>)}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}